import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
// There is no `legacy-datepicker` — Material kept a single MDC datepicker. The
// dialog template uses `<mat-datepicker>` which resolves against this module.
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { EngageCarriersDialogComponent } from '../../project/engage-carriers-dialog/engage-carriers-dialog.component';

/**
 * Shared module that owns the "Log a call / Engage carriers" dialog
 * (CN-8312 origin in project, generalized in CN-8587).
 *
 * The dialog was originally project-scoped but its UX — typeahead a contact,
 * note who you talked to, log the call — is reusable wherever we want to
 * capture a carrier contact attempt. Anything that wants to open the dialog
 * imports this module instead of pulling in the entire ProjectModule.
 *
 * Today: ProjectModule (engage/procure carrier flows), Recommended Carriers
 * Reports page (log a call from the manager list).
 */
@NgModule({
	declarations: [EngageCarriersDialogComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatDatepickerModule,
		MatDialogModule,
		MatDividerModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatNativeDateModule,
		MatOptionModule,
		MatSelectModule,
	],
	exports: [EngageCarriersDialogComponent],
})
export class CarriersDialogModule {}
